module.exports = __webpack_public_path__ + "static/media/card_04.92b99337.png";